module.exports = __webpack_public_path__ + "static/media/M1-8-Braduk-cod107.c5f002fb.png";